import { Link } from "react-router-dom";

const Footer = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  
  // Check if user is logged in and is a chef
  const isLoggedInChef = user && user.is_chef === 1;

  return (
    <>
<footer className="bg-gradient-to-br from-gray-800 to-black text-white py-20 relative overflow-hidden text-lg">
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    <div className="absolute top-10 left-10 w-32 h-32 bg-red-500/5 rounded-full blur-3xl animate-pulse"></div>
    <div className="absolute bottom-20 right-20 w-48 h-48 bg-red-400/3 rounded-full blur-3xl animate-pulse" style={{animationDelay: '2s'}}></div>
    <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-red-300/4 rounded-full blur-2xl animate-pulse" style={{animationDelay: '1s'}}></div>
    <div className="absolute top-16 right-1/4 w-2 h-2 bg-red-500/40 rounded-full animate-bounce" style={{animationDuration: '3s'}}></div>
    <div className="absolute bottom-32 left-1/4 w-1 h-1 bg-red-400/60 rounded-full animate-bounce" style={{animationDuration: '4s', animationDelay: '1s'}}></div>
    <div className="absolute top-1/3 right-16 w-1.5 h-1.5 bg-red-300/50 rounded-full animate-bounce" style={{animationDuration: '5s', animationDelay: '2s'}}></div>
  </div>

  <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-12 relative z-10">
    <div className="space-y-6 group">
      <div className="flex items-center space-x-3">
        <Link to="/" className="transform hover:scale-105 transition-all duration-300">
          <div className="relative">
            <img
              src="/media/frontend/img/logo/new/line-logo1.png"
              className="w-[140px] img-fluid transition-all duration-300 group-hover:brightness-110"
              alt="Logo"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-red-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded"></div>
          </div>
        </Link>
      </div>
      <p className="text-gray-300 leading-relaxed font-light hover:text-gray-200 transition-colors duration-300 text-base">
        Shefs Cloud works with a team of talented and passionate home shefs who combine taste, health, and quality to create mouthwatering meals for you. Every shef is carefully selected to ensure they meet our high standards for hygiene, skill, and dedication. From traditional home recipes to innovative dishes, our experts bring their culinary expertise to your plate.
      </p>
    </div>
    {/* Google Play Button */}
    <div className="pt-4 flex flex-col gap-2">
      <a
        href="https://play.google.com/store/apps/details?id=com.anonymous.shefscloud_mobile"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get it on Google Play"
        className="inline-flex w-fit hover:scale-[1.03] active:scale-[0.98] transition-transform duration-300"
      >
        <img
          src="/GetItOnGooglePlay_Badge_Web_color_English.svg"
          alt="Get it on Google Play"
          className="h-[56px] w-auto"
        />
      </a>

      {/* Legal attribution required by Google */}
      <p className="text-gray-400 text-sm leading-snug">
        Google Play is a trademark of Google LLC.
      </p>
    </div>

    <div className="transform hover:translate-y-[-2px] transition-all duration-300">
      <h3 className="text-2xl font-bold mb-6 text-white relative">
        Get to Know Us
        <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-500 to-red-600 group-hover:w-full transition-all duration-500"></div>
      </h3>
      <ul className="space-y-4 text-gray-400">
        <li className="transform hover:translate-x-2 transition-all duration-300">
          <Link to="/about" className="hover:text-red-600 transition-colors duration-300 font-medium relative group text-lg">
            <span className="relative z-10">About Us</span>
            <div className="absolute inset-0 bg-red-500/10 scale-0 group-hover:scale-100 transition-transform duration-300 rounded"></div>
          </Link>
        </li>
        <li className="transform hover:translate-x-2 transition-all duration-300">
          <Link 
            to="/terms-of-services" 
            className="hover:text-red-600 transition-colors duration-300 font-medium relative group text-lg"
          >
            <span className="relative z-10">Terms of Service</span>
            <div className="absolute inset-0 bg-red-500/10 scale-0 group-hover:scale-100 transition-transform duration-300 rounded"></div>
          </Link>
        </li>
        <li className="transform hover:translate-x-2 transition-all duration-300">
          <Link 
            to="/privacy-policy" 
            className="hover:text-red-600 transition-colors duration-300 font-medium relative group text-lg"
          >
            <span className="relative z-10">Privacy Policy</span>
            <div className="absolute inset-0 bg-red-500/10 scale-0 group-hover:scale-100 transition-transform duration-300 rounded"></div>
          </Link>
        </li>
      </ul>
    </div>
    <div className="transform hover:translate-y-[-2px] transition-all duration-300">
      <h3 className="text-2xl font-bold mb-6 text-white relative">
        Doing Business
        <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-500 to-red-600 group-hover:w-full transition-all duration-500"></div>
      </h3>
      <ul className="space-y-4 text-gray-400">
        {!isLoggedInChef && (
          <li className="transform hover:translate-x-2 transition-all duration-300">
            <Link 
              to="/become-a-chef" 
              className="hover:text-red-600 transition-colors duration-300 font-medium relative group text-lg"
            >
              <span className="relative z-10">Become a Shef</span>
              <div className="absolute inset-0 bg-red-500/10 scale-0 group-hover:scale-100 transition-transform duration-300 rounded"></div>
            </Link>
          </li>
        )}
        <li className="transform hover:translate-x-2 transition-all duration-300">
          <Link 
            to="/homemade-food-delivery" 
            className="hover:text-red-600 transition-colors duration-300 font-medium relative group text-lg"
          >
            <span className="relative z-10">Home Food Delivery</span>
            <div className="absolute inset-0 bg-red-500/10 scale-0 group-hover:scale-100 transition-transform duration-300 rounded"></div>
          </Link>
        </li>
        <li className="transform hover:translate-x-2 transition-all duration-300">
          <Link 
            to="/faqs" 
            className="hover:text-red-600 transition-colors duration-300 font-medium relative group text-lg"
          >
            <span className="relative z-10">FAQs</span>
            <div className="absolute inset-0 bg-red-500/10 scale-0 group-hover:scale-100 transition-transform duration-300 rounded"></div>
          </Link>
        </li>
      </ul>
    </div>
    <div className="transform hover:translate-y-[-2px] transition-all duration-300">
      <h3 className="text-2xl font-bold mb-6 text-white relative">
        Customer Support
        <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-500 to-red-700 group-hover:w-full transition-all duration-500"></div>
      </h3>
      <ul className="space-y-5 text-gray-300">
        <li className="flex items-center space-x-4 group hover:bg-white/5 p-3 rounded-lg transition-all duration-300">
          <div className="bg-red-500/20 rounded-lg p-3 group-hover:bg-red-500/30 group-hover:scale-110 transition-all duration-300">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="rgba(236,32,68,1)"
              className="group-hover:scale-110 transition-transform duration-300"
            >
              <path d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z"></path>
            </svg>
          </div>
          <span className="font-medium group-hover:text-white transition-colors duration-300 text-lg">+92 320 2024035</span>
        </li>
        <li className="flex items-center space-x-4 group hover:bg-white/5 p-3 rounded-lg transition-all duration-300">
          <div className="bg-red-500/20 rounded-lg p-3 group-hover:bg-red-500/30 group-hover:scale-110 transition-all duration-300">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="rgba(236,32,68,1)"
              className="group-hover:scale-110 transition-transform duration-300"
            >
              <path d="M2 5.5V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V19H20V7.3L12 14.5L2 5.5ZM0 10H5V12H0V10ZM0 15H8V17H0V15Z"></path>
            </svg>
          </div>
          <span className="font-medium group-hover:text-white transition-colors duration-300 text-lg">info@shefscloud.com</span>
        </li>
        <li className="flex items-center space-x-5 pt-4">
          {/* WhatsApp chat disabled for now — uncomment to re-enable
          <a
  href="https://wa.me/923202024035"
  target="_blank"
  rel="noopener noreferrer"
  className="hover:scale-110 transition-transform duration-300 relative group"
>
  <div className="absolute inset-0 bg-green-400/20 rounded-full scale-0 group-hover:scale-150 transition-transform duration-300 blur-lg"></div>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="36" height="36" fill="none" className="relative z-10">
    <circle cx="128" cy="128" r="128" fill="#25D366" />
    <path
      d="M128 37.25c-49.92 0-90.75 40.84-90.75 90.75 0 16.25 4.35 32.08 12.58 45.79L37.25 218l44.47-12.34c13.17 7.8 28.36 12.34 46.28 12.34 49.92 0 90.75-40.84 90.75-90.75S177.92 37.25 128 37.25ZM128 197c-14.92 0-28.75-3.99-40.7-11.34l-2.89-1.77-26.41 7.31 7.06-25.58-1.82-2.92C53.07 150.4 49.25 139.5 49.25 128c0-43.56 35.19-78.75 78.75-78.75s78.75 35.19 78.75 78.75-35.19 78.75-78.75 78.75Zm45.77-60.74c-2.51-1.25-14.84-7.35-17.14-8.19-2.29-.83-3.97-1.25-5.65 1.25-1.66 2.5-6.49 8.18-7.97 9.86-1.49 1.66-2.91 1.87-5.42.62-2.51-1.25-10.6-3.89-20.18-12.39-7.45-6.64-12.45-14.84-13.91-17.35-1.45-2.5-.16-3.86 1.09-5.12 1.12-1.13 2.49-2.93 3.73-4.4 1.25-1.46 1.66-2.49 2.49-4.15.83-1.66.42-3.12-.17-4.37-.62-1.25-5.41-13.46-7.41-18.66-1.97-5.26-3.98-4.54-5.65-4.63-1.46-.08-3.12-.08-4.78-.08-1.66 0-4.37.62-6.67 3.12-2.29 2.5-8.71 8.51-8.71 20.77 0 12.25 8.93 24.08 10.18 25.74 1.25 1.66 17.57 27.2 42.92 37.99 25.32 10.8 25.32 7.2 29.8 6.72 4.45-.5 14.49-5.88 16.54-11.54 2.08-5.66 2.08-10.5 1.46-11.54-.62-1.04-2.29-1.66-4.8-2.91Z"
      fill="#fff"
    />
  </svg>
</a>
          */}

          <a href="https://www.facebook.com/shefscloud" className="hover:scale-110 transition-transform duration-300 relative group">
            <div className="absolute inset-0 bg-blue-500/20 rounded-full scale-0 group-hover:scale-150 transition-transform duration-300 blur-lg"></div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="36" height="36" fill="none" className="relative z-10">
              <circle cx="128" cy="128" r="128" fill="#1877F2" />
              <path
                d="M154.36 102.4h-18.8v-10.54c0-4.47 2.93-5.53 4.85-5.53h13.96V70.07l-19.18-.02c-10.2 0-17.06 6.95-17.06 17.45v12.9h-11.68v15.2h11.68v44.56h19.1v-44.56h13.47l2.16-15.2Z"
                fill="#fff"
              />
            </svg>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div className="border-t border-white/10 mt-16 pt-10 text-center relative">
    <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-red-500/50 to-transparent"></div>
    <p className="text-gray-400 font-medium hover:text-gray-300 transition-colors duration-300 text-lg">
      <span className="font-bold text-red-600 hover:text-red-700 transition-colors duration-300">Shefs Cloud</span> © 2026. All Rights Reserved.
    </p>
  </div>

  <style>{`
    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    .group:hover h3::after {
      width: 100%;
    }
  `}</style>
</footer>
    </>
  );
};

export default Footer;